import React from "react";
import { AiFillFire } from "react-icons/ai";
import { BsMoonStarsFill } from "react-icons/bs";
import { IoIosHeart } from "react-icons/io";
import StatCard from "../ui/StatCard";

const ResultsWrapper = ({}) => (
    <div className="my-24 mx-[6%]">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <StatCard icon={<BsMoonStarsFill className="w-24 h-auto fill-ink"/>} value={"86%"}>
                ont vu leur sommeil s’améliorer rapidement
            </StatCard>
            <StatCard icon={<AiFillFire className="w-24 h-auto fill-ink"/>} value={"82%"}>
                sont moins stressés, moins anxieux et plus détendus, plus sereins
            </StatCard>
            <StatCard icon={<IoIosHeart className="w-24 h-auto fill-ink"/>} value={"88%"}>
                se sentent mieux mentalement et physiquement
            </StatCard>
        </div>
        <p className="container mx-auto mt-8 text-center text-lg">* Données issues d’une étude interne sur un échantillon d’utilisateurs Happiz</p>
    </div>
)

export default ResultsWrapper